import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { otpValidation } from '../models/otpValidation.model';

@Injectable({
  providedIn: 'root',
})
export class AccountService {
  private ACCOUNT_LISTS: any;
  private USER_INFO: any;
  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
    
  };
  ACCOUNT_IMG_LISTS: any;
  
  constructor(private http: HttpClient) {}
  getAllAccount() {
    if (this.ACCOUNT_LISTS)
      return this.convertObjectInObservable(this.ACCOUNT_LISTS);
    return this.AllAccount();
  }

  getAllAccountIMG() {
    if (this.ACCOUNT_IMG_LISTS)
      return this.convertObjectInObservable(this.ACCOUNT_IMG_LISTS);
    return this.AllAccountIMG();
  }
//
  getUInfo(){
    return this.USER_INFO;
  }
  
getAList(){
  return this.ACCOUNT_LISTS;
}

  AllAccount() {
    return this.http
      .post(
        `${environment.ECARE_URL}/getAllAccountServices.service`,
        {},
        this.httpOptions
      )
      .pipe(
        map((R: any) => {
          this.ACCOUNT_LISTS = R;
          return R;
        })
      );
  }

  AllAccountIMG() {
    return this.http
      .post(
        `${environment.ECARE_URL}/allAccountsImages.service`,
        {},
        this.httpOptions
      )
      .pipe(
        map((R: any) => {
          this.ACCOUNT_LISTS = R;
          return R;
        })
      );
  }
  getAccountInfo(payload) {
    return this.http
      .post(
        `${environment.ECARE_URL}/getAccountInfo.service`,
        payload,
        this.httpOptions
      )
  }


  getCategoryInfo(payload) {
    return this.http
      .post(
        `${environment.ECARE_URL}/getCategoryInfo.service`,
        payload,
        this.httpOptions
      )
      
  }

  getUserInfo() {
    if (this.ACCOUNT_LISTS)
      return this.convertObjectInObservable(this.USER_INFO);
    return this.UserInfo();
  }

  UserInfo() {
    return this.http
      .post(
        `${environment.ECARE_URL}/getUserInfo.service`,
        {},
        this.httpOptions
      )
      .pipe(
        map((R: any) => {
          this.USER_INFO = R;
          return R;
        })
      );
  }

  private convertObjectInObservable(D: any): Observable<any> {
    const OBS = new Observable<any>((O) => {
      O.next(D);
      O.complete();
    });
    return OBS;
  }

  getMobileEligibility(accountNo:number): Observable<any> {
    const payload = { accountNo: accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/accountNoIndividualLoginEligibility.service`,
      payload,
      this.httpOptions
    );
  }

  generateOTP(accountNo:number):Observable<any>{
    const payload = { "accountNo":accountNo, "notificationType":"SMS", "notificationValue":accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/generateOtpByAccountNo.service`,
      payload,
      this.httpOptions
    );
  }

  logout():Observable<any>{
    return this.http.post(
      `${environment.ECARE_URL}/logoutUser.service`,{},
      this.httpOptions
    );
  }

  loginwithOTP(otpValidation:otpValidation):Observable<any>{
    return this.http.post(
      `${environment.ECARE_URL}/loginWithCustomAuthentication.service`,
      otpValidation,
      this.httpOptions
    );
  }

  
  getAccountType(accountNo:number): Observable<any> {
    const payload = { accountNumber: accountNo };
    return this.http.post(
      `${environment.ECARE_URL}/cqtGetAccountType.service`,
      payload,
      this.httpOptions
    );
  }

  

  logOut() {
    return this.http.post(
      `${environment.ECARE_URL}/logoutUser.service`,
      {},
      this.httpOptions
    );
  }

  getShoppingCart() {
    return this.http.get(
      `${environment.BASE_URL}/getShoppingCart`,
      this.httpOptions
    );
  }

}
